var platforms = ["youtube", "vimeo", "videopress", "twitch", "twitchlive", "niconico"];

function extractVideo(video) {
  var keywords = platforms.join("|");
  var re = new RegExp("(" + keywords + "):(.*)", "i");
  var processValue = video.match(re);

  if (processValue && processValue[2]) {
    var type = processValue[1].trim();
    var link = processValue[2].trim();
    return "<div video-link=\"" + link + "\" video-type=\"" + type + "\"></div>";
  }

  return video;
}

export function fn(source) {
  var INLINE_CODE_MD_REGEX = /(`)(.*?)\1/g;
  return source.replace(INLINE_CODE_MD_REGEX, function (substring) {
    INLINE_CODE_MD_REGEX.lastIndex = 0;
    var matched = INLINE_CODE_MD_REGEX.exec(substring);

    if (matched && matched[2]) {
      return extractVideo(matched[2]);
    }

    return substring;
  });
}
export var embedVideoMutationPlugin = function embedVideoMutationPlugin(_a) {
  var source = _a.source;
  return fn(source.content || source.rawContent);
};